import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "@babel/polyfill";
import "@/styles/styles.scss";

import Loader from "./components/loaders/Loader";
import LoaderHover from "./components/loaders/LoaderHover";

Vue.component("loader", Loader);
Vue.component("loader-hover", LoaderHover);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
